"use client";

/**
 * Client component for rendering the current year.
 * This is needed because new Date() is non-deterministic
 * and cannot be used in server components with Cache Components.
 */
export function CopyrightYear() {
  return <>{new Date().getFullYear()}</>;
}
